/* eslint-disable max-len */
import { SvgIcon, SvgIconProps } from '@mui/material';

export default function DownloadIcon(props: SvgIconProps) {
  return (
    <SvgIcon xmlns="http://www.w3.org/2000/svg" width="19" height="23" viewBox="0 0 19 23" fill="none" {...props}>
      <path d="M0 22.6667H18.6667V20H0V22.6667ZM18.6667 8H13.3333V0H5.33333V8H0L9.33333 17.3333L18.6667 8Z" />
    </SvgIcon>
  );
}
